"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersionGroups = exports.Versions = exports.Pokedexes = exports.Generations = void 0;
var Generations;
(function (Generations) {
    Generations[Generations["GENERATION_I"] = 1] = "GENERATION_I";
    Generations[Generations["GENERATION_II"] = 2] = "GENERATION_II";
    Generations[Generations["GENERATION_III"] = 3] = "GENERATION_III";
    Generations[Generations["GENERATION_IV"] = 4] = "GENERATION_IV";
    Generations[Generations["GENERATION_V"] = 5] = "GENERATION_V";
    Generations[Generations["GENERATION_VI"] = 6] = "GENERATION_VI";
    Generations[Generations["GENERATION_VII"] = 7] = "GENERATION_VII";
    Generations[Generations["GENERATION_VIII"] = 8] = "GENERATION_VIII";
})(Generations = exports.Generations || (exports.Generations = {}));
var Pokedexes;
(function (Pokedexes) {
    Pokedexes[Pokedexes["NATIONAL"] = 1] = "NATIONAL";
    Pokedexes[Pokedexes["KANTO"] = 2] = "KANTO";
    Pokedexes[Pokedexes["ORIGINAL_JOHTO"] = 3] = "ORIGINAL_JOHTO";
    Pokedexes[Pokedexes["HOENN"] = 4] = "HOENN";
    Pokedexes[Pokedexes["ORIGINAL_SINNOH"] = 5] = "ORIGINAL_SINNOH";
    Pokedexes[Pokedexes["EXTENDED_SINNOH"] = 6] = "EXTENDED_SINNOH";
    Pokedexes[Pokedexes["UPDATED_JOHTO"] = 7] = "UPDATED_JOHTO";
    Pokedexes[Pokedexes["ORIGINAL_UNOVA"] = 8] = "ORIGINAL_UNOVA";
    Pokedexes[Pokedexes["UPDATED_UNOVA"] = 9] = "UPDATED_UNOVA";
    Pokedexes[Pokedexes["CONQUEST_GALLERY"] = 11] = "CONQUEST_GALLERY";
    Pokedexes[Pokedexes["KALOS_CENTRAL"] = 12] = "KALOS_CENTRAL";
    Pokedexes[Pokedexes["KALOS_COASTAL"] = 13] = "KALOS_COASTAL";
    Pokedexes[Pokedexes["KALOS_MONTAIN"] = 14] = "KALOS_MONTAIN";
    Pokedexes[Pokedexes["UPDATED_HOENN"] = 15] = "UPDATED_HOENN";
    Pokedexes[Pokedexes["ORIGINAL_ALOLA"] = 16] = "ORIGINAL_ALOLA";
    Pokedexes[Pokedexes["ORIGINAL_MELEMELE"] = 17] = "ORIGINAL_MELEMELE";
    Pokedexes[Pokedexes["ORIGINAL_AKALA"] = 18] = "ORIGINAL_AKALA";
    Pokedexes[Pokedexes["ORIGINAL_ULAULA"] = 19] = "ORIGINAL_ULAULA";
    Pokedexes[Pokedexes["ORIGINAL_PONI"] = 20] = "ORIGINAL_PONI";
    Pokedexes[Pokedexes["UPDATED_ALOLA"] = 21] = "UPDATED_ALOLA";
    Pokedexes[Pokedexes["UPDATED_MELEMELE"] = 22] = "UPDATED_MELEMELE";
    Pokedexes[Pokedexes["UPDATED_AKALA"] = 23] = "UPDATED_AKALA";
    Pokedexes[Pokedexes["UPDATED_ULAULA"] = 24] = "UPDATED_ULAULA";
    Pokedexes[Pokedexes["UPDATED_PONI"] = 25] = "UPDATED_PONI";
    Pokedexes[Pokedexes["UPDATED_KANTO"] = 26] = "UPDATED_KANTO";
    Pokedexes[Pokedexes["GALAR"] = 27] = "GALAR";
    Pokedexes[Pokedexes["ISLE_OF_ARMOR"] = 28] = "ISLE_OF_ARMOR";
    Pokedexes[Pokedexes["CROWN_TUNDRA"] = 29] = "CROWN_TUNDRA";
})(Pokedexes = exports.Pokedexes || (exports.Pokedexes = {}));
var Versions;
(function (Versions) {
    Versions[Versions["RED"] = 1] = "RED";
    Versions[Versions["BLUE"] = 2] = "BLUE";
    Versions[Versions["YELLOW"] = 3] = "YELLOW";
    Versions[Versions["GOLD"] = 4] = "GOLD";
    Versions[Versions["SILVER"] = 5] = "SILVER";
    Versions[Versions["CRYSTAL"] = 6] = "CRYSTAL";
    Versions[Versions["RUBY"] = 7] = "RUBY";
    Versions[Versions["SAPPHIRE"] = 8] = "SAPPHIRE";
    Versions[Versions["EMERALD"] = 9] = "EMERALD";
    Versions[Versions["FIRERED"] = 10] = "FIRERED";
    Versions[Versions["LEAFGREEN"] = 11] = "LEAFGREEN";
    Versions[Versions["DIAMOND"] = 12] = "DIAMOND";
    Versions[Versions["PEARL"] = 13] = "PEARL";
    Versions[Versions["PLATINUM"] = 14] = "PLATINUM";
    Versions[Versions["HEARTGOLD"] = 15] = "HEARTGOLD";
    Versions[Versions["SOULSILVER"] = 16] = "SOULSILVER";
    Versions[Versions["BLACK"] = 17] = "BLACK";
    Versions[Versions["WHITE"] = 18] = "WHITE";
    Versions[Versions["COLOSSEUM"] = 19] = "COLOSSEUM";
    Versions[Versions["XD"] = 20] = "XD";
    Versions[Versions["BLACK_2"] = 21] = "BLACK_2";
    Versions[Versions["WHITE_2"] = 22] = "WHITE_2";
    Versions[Versions["X"] = 23] = "X";
    Versions[Versions["Y"] = 24] = "Y";
    Versions[Versions["OMEGA_RUBY"] = 25] = "OMEGA_RUBY";
    Versions[Versions["ALPHA_SAPPHIRE"] = 26] = "ALPHA_SAPPHIRE";
    Versions[Versions["SUN"] = 27] = "SUN";
    Versions[Versions["MOON"] = 28] = "MOON";
    Versions[Versions["ULTRA_SUN"] = 29] = "ULTRA_SUN";
    Versions[Versions["ULTRA_MOON"] = 30] = "ULTRA_MOON";
    Versions[Versions["LETS_GO_PIKACHU"] = 31] = "LETS_GO_PIKACHU";
    Versions[Versions["LETS_GO_EEVEE"] = 32] = "LETS_GO_EEVEE";
    Versions[Versions["SWORD"] = 33] = "SWORD";
    Versions[Versions["SHIELD"] = 34] = "SHIELD";
})(Versions = exports.Versions || (exports.Versions = {}));
var VersionGroups;
(function (VersionGroups) {
    VersionGroups[VersionGroups["RED_BLUE"] = 1] = "RED_BLUE";
    VersionGroups[VersionGroups["YELLOW"] = 2] = "YELLOW";
    VersionGroups[VersionGroups["GOLD_SILVER"] = 3] = "GOLD_SILVER";
    VersionGroups[VersionGroups["CRYSTAL"] = 4] = "CRYSTAL";
    VersionGroups[VersionGroups["RUBY_SAPPHIRE"] = 5] = "RUBY_SAPPHIRE";
    VersionGroups[VersionGroups["EMERALD"] = 6] = "EMERALD";
    VersionGroups[VersionGroups["FIRERED_LEAFGREEN"] = 7] = "FIRERED_LEAFGREEN";
    VersionGroups[VersionGroups["DIAMOND_PEARL"] = 8] = "DIAMOND_PEARL";
    VersionGroups[VersionGroups["PLATINUM"] = 9] = "PLATINUM";
    VersionGroups[VersionGroups["HEARTGOLD_SOULSILVER"] = 10] = "HEARTGOLD_SOULSILVER";
    VersionGroups[VersionGroups["BLACK_WHITE"] = 11] = "BLACK_WHITE";
    VersionGroups[VersionGroups["COLOSSEUM"] = 12] = "COLOSSEUM";
    VersionGroups[VersionGroups["XD"] = 13] = "XD";
    VersionGroups[VersionGroups["BLACK_2_WHITE_2"] = 14] = "BLACK_2_WHITE_2";
    VersionGroups[VersionGroups["X_Y"] = 15] = "X_Y";
    VersionGroups[VersionGroups["OMEGA_RUBY_ALPHA_SAPPHIRE"] = 16] = "OMEGA_RUBY_ALPHA_SAPPHIRE";
    VersionGroups[VersionGroups["SUN_MOON"] = 17] = "SUN_MOON";
    VersionGroups[VersionGroups["ULTRA_SUN_ULTRA_MOON"] = 18] = "ULTRA_SUN_ULTRA_MOON";
    VersionGroups[VersionGroups["LETS_GO"] = 19] = "LETS_GO";
    VersionGroups[VersionGroups["SWORD_SHIELD"] = 20] = "SWORD_SHIELD";
})(VersionGroups = exports.VersionGroups || (exports.VersionGroups = {}));
